import { render, staticRenderFns } from "./EipPagination.vue?vue&type=template&id=28c7a6cc&scoped=true&"
import script from "./EipPagination.vue?vue&type=script&lang=js&"
export * from "./EipPagination.vue?vue&type=script&lang=js&"
import style0 from "./EipPagination.vue?vue&type=style&index=0&id=28c7a6cc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c7a6cc",
  null
  
)

export default component.exports